import type { AxiosError } from "axios"
import axios from "axios"
import axiosRetry, { exponentialDelay, isNetworkError, isRetryableError } from "axios-retry"
import { debounce } from "underscore"
import qs from "qs"
import { initAuth } from "./auth"
import { posthog } from "posthog-js"

const api = axios.create({
    baseURL: "/api",
    timeout: 30_000,
    paramsSerializer: {
        serialize: (params) => qs.stringify(params, { encode: false }),
    },
})
axiosRetry(api, {
    retries: 3,
    retryDelay: exponentialDelay,
    retryCondition: (err) => isRetryableError(err) || isNetworkError(err), // retry all HTTP methods
})

const handleUnauthorized = debounce(
    () => {
        initAuth(api)
    },
    3000,
    true,
)

api.interceptors.request.use((config) => {
    return config
})

api.interceptors.response.use(
    (resp) => resp,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            handleUnauthorized()
        }
        throw error
    },
)

export default api
